// @flow

import type { State } from "@store/reducers";
import type {
  ServiceSettings,
  ServiceSettingsContainer,
} from "@modules/service/reducer/service-settings/types";

export const getServiceSettings = (state: State): ServiceSettingsContainer =>
  state.service.serviceSettings.settings;

export const getServiceSettingsSchema = (state: State): ?Object =>
  (state.service.serviceSettings || {}).schema;

export const getEditedServiceSettings = (state: State): ?ServiceSettings =>
  state.service.serviceSettings.edits;

export const getShowEditServiceSettingsModal = (state: State): boolean =>
  state.service.serviceSettings.modals.showEditModal;

export const getEditServiceSettingsModalStep = (state: State): number =>
  state.service.serviceSettings.modals.modalStep;

export const getShowSubmitServiceSettingsModal = (state: State): boolean =>
  state.service.serviceSettings.modals.showSubmitModal;

export const getClientActiveServiceSettings = (state: State): ?ServiceSettings => {
  return state.service.serviceSettings.settings.active;
};
